var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.945H6V2C6 1.46957 5.78929 0.960859 5.41421 0.585786C5.03914 0.210714 4.53043 0 4 0C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V2.945H1.5C1.10218 2.945 0.720644 3.10304 0.43934 3.38434C0.158035 3.66564 0 4.04718 0 4.445V8.445C0 8.84282 0.158035 9.22436 0.43934 9.50566C0.720644 9.78696 1.10218 9.945 1.5 9.945H6.5C6.89782 9.945 7.27936 9.78696 7.56066 9.50566C7.84196 9.22436 8 8.84282 8 8.445V4.445C8 4.04718 7.84196 3.66564 7.56066 3.38434C7.27936 3.10304 6.89782 2.945 6.5 2.945ZM3 2C2.99327 1.72765 3.09472 1.46372 3.28214 1.266C3.46956 1.06827 3.72768 0.952852 4 0.945C4.27232 0.952852 4.53044 1.06827 4.71786 1.266C4.90528 1.46372 5.00673 1.72765 5 2V2.945H3V2ZM7 8.445C7 8.57761 6.94732 8.70479 6.85355 8.79855C6.75979 8.89232 6.63261 8.945 6.5 8.945H1.5C1.36739 8.945 1.24021 8.89232 1.14645 8.79855C1.05268 8.70479 1 8.57761 1 8.445V4.445C1 4.31239 1.05268 4.18521 1.14645 4.09145C1.24021 3.99768 1.36739 3.945 1.5 3.945H6.5C6.63261 3.945 6.75979 3.99768 6.85355 4.09145C6.94732 4.18521 7 4.31239 7 4.445V8.445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d14b179f.svg";
export { ForwardRef as ReactComponent };